import request from "@/utils/request";

// 产品与服务父级菜单
export function getIndustry(){
    return request.post('/home/getIndustry')
}

// 产品与服务子级菜单
export function getIndustryList(id) {
    return request({
      url: '/home/getIndustryList/'+id,
      method: 'get',
    });
}

// 产品服务列表和界面详情
export function getIndustryListPageInfo(id) {
  return request({
    url:'/home/getIndustryPageInfoOrIndustryListInfo/'+id,
    method:'get'
  })
}

// 点击产品服务列表详情
export function getIndustryListInfo(id) {
  console.log(id,0);
  return request({
    url: "/home/getIndustryListInfo",
    method: 'post',
    data:{
      id
    }
  })
}